import { Phone, Mail, MapPin } from "lucide-react";

const CHRIS_PHOTO = "https://customer-assets.emergentagent.com/job_a0897f07-e635-4cd5-9eb9-21140ceaa71c/artifacts/nmta0a2n_brookebarclayphotography-1-10.jpg";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#132723] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Agent Info */}
          <div className="flex items-center gap-4">
            <img 
              src={CHRIS_PHOTO} 
              alt="Chris Pierog" 
              className="w-14 h-14 rounded-full object-cover"
            />
            <div>
              <h3 className="text-lg font-serif">Chris Pierog</h3>
              <p className="text-white/70 text-sm">Realtor® | Spivey Realty Group</p>
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-2">
            <a 
              href="tel:+13605810167" 
              className="flex items-center gap-2 text-white/70 hover:text-white transition-colors"
            >
              <Phone className="w-4 h-4" />
              <span>(360) 581-0167</span>
            </a>
            <a 
              href="mailto:chris@spiveyrealtygroup.com" 
              className="flex items-center gap-2 text-white/70 hover:text-white transition-colors"
            >
              <Mail className="w-4 h-4" />
              <span>chris@spiveyrealtygroup.com</span>
            </a>
            <div className="flex items-start gap-2 text-white/70">
              <MapPin className="w-4 h-4 mt-0.5" />
              <span>141 S Main St, Montesano, WA 98563</span>
            </div>
          </div>

          {/* Areas */}
          <div>
            <p className="text-sm text-white/50 mb-2">Serving</p>
            <p className="text-sm text-white/70">
              Aberdeen • Hoquiam • Montesano • Ocean Shores • Westport • Grays Harbor County • Pacific County
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 pt-6 text-center">
          <p className="text-sm text-white/50">
            &copy; {currentYear} Chris Pierog | Spivey Realty Group. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
